import { ILeaf, INode } from 'shared/types/tree'
import { traverseTree } from 'components/utility/TreeHelpers'

const filteredKeys = [
  'created_at',
  'updated_at',
  'user',
  'tempID',
  'depth',
  'has_overview',
]

function filterKeys(filtered: string[]) {
  return <T extends INode | ILeaf>(item: T) => {
    return Object.entries(item).reduce<T>((acc, [key, value]) => {
      if (filtered.includes(key) || !value) return acc
      return {
        ...acc,
        [key]: value,
      }
    }, {} as T)
  }
}

// This function removes all reference nodes and filters out unnecessary keys
export function normalizeTreeForJsonView(tree: INode, filters = filteredKeys) {
  const keyFilter = filterKeys(filters)
  const copied = keyFilter(tree)
  const nodeFilter = (n: INode) => {
    n.nodes = n.nodes.reduce<INode[]>((acc, n) => {
      if (!n.type) return acc
      if (n.type.startsWith('reference:')) return acc
      if (n.leaves?.length) {
        n.leaves = n.leaves?.map(keyFilter)
      }
      return [...acc, keyFilter(n)]
    }, [])
  }

  for (const node of traverseTree(copied)) {
    nodeFilter(node)
  }

  return copied
}

export function normalizeSourceTree(tree: INode) {
  return normalizeTreeForJsonView(tree, [
    ...filteredKeys,
    'tree_id',
    'version',
    'parent_id',
    'id',
  ])
}

// These counts are used to show how many nodes will be deleted when the user
// is using the delete action option
export function countChildren(node: INode) {
  const counts = { nodes: 0, leaves: 0 }
  const nodeCheck = (node: INode) => {
    counts.nodes += 1
    counts.leaves += node.leaves?.length ?? 0
  }

  for (const n of traverseTree(node)) {
    nodeCheck(n)
  }

  return counts
}
